<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR CARTÓRIO' : 'NOVO CARTÓRIO'" titleIcon="fas fa-edit">

            <div v-if="modoEdicao && !carregado" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="16">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]">
                            <el-input v-model="dados.nome" maxlength="150" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Situação">
                            <el-select v-model="dados.situacao" style="width: 100%;">
                                <el-option :value="true" label="ATIVO"></el-option>
                                <el-option :value="false" label="INATIVO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24">
                        <el-form-item label="Serventia">
                            <el-input v-model="dados.serventia" maxlength="150"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Estado (UF)">
                            <el-select v-model="estadoId" @change="onChangeEstado" filterable clearable style="width: 100%;" placeholder="Selecione o estado">
                                <el-option v-for="e in estados" :key="e.id" :label="e.nome" :value="e.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Cidade" prop="cidade_id" :rules="[$requiredChange]">
                            <el-select v-model="dados.cidade_id" filterable clearable :disabled="!estadoId || carregandoCidades" :loading="carregandoCidades" style="width: 100%;" placeholder="Selecione a cidade">
                                <el-option v-for="c in cidades" :key="c.id" :label="c.nome" :value="c.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/cartorio">
                            <el-button>VOLTAR</el-button>
                        </router-link>
                        <el-button class="u-ml-10" type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        dados: { nome: '', situacao: true, serventia: '', cidade_id: null },
        estadoId: null,
        estados: [],
        cidades: [],
        carregandoCidades: false,
        modoEdicao: false,
        carregado: false
    }),
    mounted () {
        this.carregarEstados()
        if (this.$route.params.id) {
            this.modoEdicao = true
            this.carregar(this.$route.params.id)
        }
    },
    methods: {
        carregarEstados () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/estado/getAll`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.estados = r.data || [] }).catch(e => this.$store.commit('throwException', e))
        },
        carregarCidades (estadoId) {
            if (!estadoId) { this.cidades = []; return Promise.resolve() }
            this.carregandoCidades = true
            return this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/cidade/getAllCidadesByEstado/${estadoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.cidades = r.data || []; this.carregandoCidades = false })
             .catch(e => { this.carregandoCidades = false; this.$store.commit('throwException', e) })
        },
        onChangeEstado () {
            this.dados.cidade_id = null
            this.carregarCidades(this.estadoId)
        },
        carregar (id) {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/cartorio/getById/${id}`,
                this.$store.getters.getHeaderAuth
            ).then(async r => {
                const reg = r.data || {}
                this.dados.nome = reg.nome || ''
                this.dados.serventia = reg.serventia || ''
                this.dados.situacao = reg.situacao === null || reg.situacao === undefined ? true : reg.situacao
                if (reg.cidade) {
                    this.estadoId = reg.cidade.estado_id || (reg.cidade.estado ? reg.cidade.estado.id : null)
                    await this.carregarCidades(this.estadoId)
                    this.dados.cidade_id = reg.cidade_id
                }
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/cartorio/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/cartorio/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })
                    this.$router.push('/admin/cartorio')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
